// extracted by mini-css-extract-plugin
export default {"modal":"kNf5tE"};